import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnter = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M8.25 12.7578L11.2578 9.75L8.25 6.76953V8.21875C8.25 8.60156 7.94922 8.875 7.59375 8.875H4.3125L4.3125 10.625L7.59375 10.625C7.94922 10.625 8.25 10.9258 8.25 11.2812V12.7578ZM12.625 9.75C12.625 10.0781 12.4883 10.3789 12.2695 10.5977L9.09766 13.7695C8.85156 14.0156 8.52344 14.125 8.19531 14.125C7.48438 14.125 6.9375 13.5781 6.9375 12.8672V11.9375H4.3125C3.57422 11.9375 3 11.3633 3 10.625L3 8.875C3 8.16406 3.57422 7.5625 4.3125 7.5625L6.9375 7.5625V6.66016C6.9375 5.94922 7.48438 5.375 8.19531 5.375C8.52344 5.375 8.85156 5.51172 9.09766 5.75781L12.2695 8.92969C12.4883 9.14844 12.625 9.44922 12.625 9.75ZM12.4063 14.5625H14.5938C15.1953 14.5625 15.6875 14.0977 15.6875 13.4687L15.6875 6.03125C15.6875 5.42969 15.1953 4.9375 14.5938 4.9375H12.4062C12.0234 4.9375 11.75 4.66406 11.75 4.28125C11.75 3.92578 12.0234 3.625 12.4062 3.625H14.5938C15.9062 3.625 17 4.71875 17 6.03125V13.4687C17 14.8086 15.9063 15.875 14.5938 15.875H12.4063C12.0234 15.875 11.75 15.6016 11.75 15.2187C11.75 14.8633 12.0234 14.5625 12.4063 14.5625Z"
	})
});
const ForwardRef = forwardRef(SvgEnter);
export default ForwardRef;
